<script setup lang="ts">
import {useStore} from "vuex";
import {computed} from "vue";

import ButtonStrip from "@/components/UI/ButtonStrip.vue";
import ButtonPrimitive from "@/components/UI/ButtonPrimitive.vue";
import {CutoutTypes} from "@/Models/CutoutTypes";

const store = useStore();
const cutoutType = computed(() => store.getters.cutoutType );
const cutoutSelectorButtons = computed(() => store.getters.cutoutSelectorButtons );
const activeItemIndex = computed(() => {
	const index = cutoutSelectorButtons.value.findIndex( ( item: {
		active: boolean;
	} ) => item.active === true);

	return index === -1 ? 0 : index;
});

async function updateCutoutType( type: CutoutTypes ) {

	// Get current type
	if ( cutoutType.value === CutoutTypes.none && type !== CutoutTypes.none ) {
		store.commit("updateCutoutType", type );

		await store.dispatch("updateDefaultCutoutMeasurements");
	}

	// reset correctly when going from text to shape
	if ( cutoutType.value === CutoutTypes.text && type === CutoutTypes.shape ) {
		await store.dispatch( "resetCutouts" );
		store.commit("updateCutoutType", type );
		await store.dispatch("updateDefaultCutoutMeasurements");
	}

	if ( type === CutoutTypes.text ) {
		store.commit("updateCutoutShape", "text");
		await store.dispatch("updateDefaultCutoutMeasurements");
		await store.dispatch( "text/setDefaults", true, { root: true } );
	}

	store.commit("updateCutoutType", type );

	if( type === CutoutTypes.none ) {
		await store.dispatch( "resetCutouts" );
	}
}

</script>

<template>
	<button-strip :total-buttons="cutoutSelectorButtons.length" :buttons-per-row="5" :selected-item="activeItemIndex">
		<button-primitive
			v-for="(item, index) in cutoutSelectorButtons"
			:on-click="() => updateCutoutType(item.selection)"
			:icon="item.icon"
			:text="item.text"
			:index="index"
			:is-active="item.selection === cutoutType"
		/>
	</button-strip>
</template>
